import { render, staticRenderFns } from "./FormulareUDownloads.vue?vue&type=template&id=025603a8&scoped=true&"
import script from "./FormulareUDownloads.vue?vue&type=script&lang=js&"
export * from "./FormulareUDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025603a8",
  null
  
)

export default component.exports